import gsap from "gsap"
import { module as BaseModule } from "modujs"
import Swiper from "swiper"
import { EffectFade, Keyboard, Navigation } from "swiper/modules"

import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"

export default class extends BaseModule {
  init() {
    const slider = this.el.querySelector(".swiper")
    const { sliderConfig } = slider.dataset

    const params = {
      project: {
        modules: [EffectFade, Navigation, Keyboard],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        speed: 500,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          prevEl: this.el.querySelector("[data-slider-prev]"),
          nextEl: this.el.querySelector("[data-slider-next]"),
        },
        loop: true,
      },
    }

    this.swiper = new Swiper(slider, params[sliderConfig])

    // Add close button functionality
    this.closeBtn = this.el.querySelector('[aria-label="Close"]')
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => this.close())
    }

    // Add keyboard support for closing
    this.handleKeydown = (e) => {
      if (e.key === "Escape") {
        this.close()
      }
    }
    document.addEventListener("keydown", this.handleKeydown)

    const thumbnails = document.querySelectorAll("[data-thumbnail-index]")
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        this.open(parseInt(thumbnail.getAttribute("data-thumbnail-index")))
      })
    })
  }

  open(slideIndex = 0) {
    this.el.style.display = "block"
    this.swiper.slideTo(slideIndex, 0)
    document.body.classList.add("has-modal")
    gsap.fromTo(
      this.el,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.8,
        ease: "power2.out",
      }
    )
    document.body.style.overflow = "hidden"
  }

  close() {
    gsap.to(this.el, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.out",
      onComplete: () => {
        this.el.style.display = "none"
        document.body.style.overflow = ""
        document.body.classList.remove("has-modal")
      },
    })
  }

  destroy() {
    // Clean up keyboard event listener
    if (this.handleKeydown) {
      document.removeEventListener("keydown", this.handleKeydown)
    }

    if (window.innerWidth >= 1024 && this.follower) {
      window.removeEventListener("mousemove", this.moveFollower)
      gsap.killTweensOf(this.follower)
      if (this.followerAreas) {
        this.followerAreas.forEach((area) => {
          area.removeEventListener("mouseenter", this.showFollower)
          area.removeEventListener("mouseleave", this.hideFollower)
        })
      }
    }
  }
}
